<nav class="navbar navbar-expand-lg fixed-top">
    <a class="navbar-brand d-flex align-items-center py-1 ms-0" routerLink="/">
        <img src="/assets/logo-large.png" class="py-1" alt="Tiwi Land Council" />
    </a>

    @if (userService.watch | async; as _user) {
        <!-- Below lg: these links collapse behind the hamburger into a scrollable panel (so any
             number of pages is fine). At lg+: they show inline and anything that won't fit folds
             into the "More" dropdown (see visibleCount / measureAndFold), so the bar can't overflow.
             The user menu and the toggler sit OUTSIDE the collapse, on the bar. -->
        <div class="collapse navbar-collapse" [ngbCollapse]="navCollapsed">
            <ul #navRow class="navbar-nav align-items-lg-center ms-lg-3 nav-row flex-lg-grow-1" [class.invisible]="!ready">
                @for (link of navLinks.slice(0, visibleCount); track link.link) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="link.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: link.exact }">{{ link.label }}</a>
                    </li>
                }
                @if (visibleCount < navLinks.length) {
                    <li class="nav-item" ngbDropdown display="dynamic">
                        <button class="nav-link more-toggle" ngbDropdownToggle type="button">More <i class="fa fa-caret-down ms-1"></i></button>
                        <div ngbDropdownMenu>
                            @for (link of navLinks.slice(visibleCount); track link.link) {
                                <a class="dropdown-item" [routerLink]="link.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: link.exact }">{{ link.label }}</a>
                            }
                        </div>
                    </li>
                }
            </ul>

            <!-- Hidden measurer: every link at natural width, read by measureAndFold() to decide how
                 many fit inline (lg+). Absolutely positioned, so it never affects the real layout. -->
            <ul class="navbar-nav flex-row nav-measure" aria-hidden="true">
                @for (link of navLinks; track link.link) {
                    <li class="nav-item"><span #measureItem class="nav-link">{{ link.label }}</span></li>
                }
            </ul>

            @if (!_user.loggedIn) {
                <!-- Applicants never need this: permits are applied for and viewed without an account.
                     It's only for TLC staff and Business Login holders, so it's labelled for them and
                     kept secondary. In the collapse; the logged-in user menu is on the bar instead. -->
                <a
                    class="btn btn-sm btn-outline-dark ms-lg-auto me-lg-3 my-2 my-lg-0 mx-3 mx-lg-0 text-nowrap"
                    routerLink="/login"
                    (click)="navCollapsed = true"
                    title="For TLC staff and organisations with a Business Login"
                >
                    <i class="fa fa-lock me-1"></i><span class="d-none d-sm-inline">Staff &amp; business </span>login
                </a>
            }
        </div>

        <!-- Logged-in user menu: its own dropdown on the bar at every width, never folded. -->
        @if (_user.loggedIn) {
            <div class="ms-auto me-2 me-lg-3" ngbDropdown display="dynamic" placement="bottom-end">
                <button class="btn profile-button" id="userDropdownMenu" ngbDropdownToggle (click)="update()">
                    <ngxh6-usericon [user]="_user.account.user" [showTooltip]="false" class="me-0"></ngxh6-usericon>
                </button>
                <div ngbDropdownMenu aria-labelledby="userDropdownMenu">
                    <h6 class="dropdown-header">{{ _user.account.user.name }}</h6>
                    @if (userService.isGranted(['ROLE_ADMIN', 'ROLE_STAFF'])) {
                        <button class="dropdown-item" routerLink="/crm"><i class="fa fa-fw fa-gauge me-2"></i> CRM</button>
                    }
                    <!-- Shown to anyone who holds a Business Login, including a TLC staff
                         account that also runs one (or is testing a BL): staff land in the
                         CRM by default and previously had no way to reach their business
                         area. The route itself only needs ROLE_BUSINESS. -->
                    @if (userService.isGranted(['ROLE_BUSINESS'])) {
                        <button class="dropdown-item" routerLink="/business"><i class="fa fa-fw fa-briefcase me-2"></i> Business area</button>
                    }
                    <button class="dropdown-item" routerLink="user-admin"><i class="fa fa-fw fa-user me-2"></i> My Profile</button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item warning" (click)="clearCaches()"><i class="fa fa-fw fa-trash me-2"></i> Clear Data Cache</button>
                    @if (!_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.logOut()"><i class="fa fa-fw fa-sign-out me-2"></i> Logout</button>
                    }
                    @if (_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.exitImpersonation()">
                            <i class="fa fa-fw fa-sign-out me-2"></i> Exit Impersonation
                        </button>
                    }
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">Theme</h6>
                    @for (theme of themeService.themesKeys; track theme) {
                        <button class="dropdown-item theme-selector" (click)="themeService.setTheme(theme)">
                            <i
                                class="fa fa-fw me-2 fa-regular"
                                [class.fa-square-check]="theme === themeService.currentTheme"
                                [class.fa-square]="theme !== themeService.currentTheme"
                            ></i>
                            {{ themeService.themes[theme] }}
                        </button>
                    }
                    <div class="dropdown-divider"></div>
                    @if (userService.hasRole('ROLE_ADMIN')) {
                        <a class="dropdown-item" routerLink="debug"> <i class="fa fa-fw fa-bug me-2"></i> Debug</a>
                    }
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">App Version {{ version }}</h6>
                    <h6 class="dropdown-header">Environment: {{ env }}</h6>
                </div>
            </div>
        }

        <!-- Hamburger: shown below lg only (Bootstrap hides it at lg+). ms-auto only when there's no
             user menu before it to push the bar's right-hand group over. -->
        <button
            class="navbar-toggler me-3"
            [class.ms-auto]="!_user.loggedIn"
            type="button"
            (click)="navCollapsed = !navCollapsed"
            [attr.aria-expanded]="!navCollapsed"
            aria-label="Toggle navigation"
        >
            <i class="fa fa-bars"></i>
        </button>
    }
</nav>
